// extracted by mini-css-extract-plugin
export default {"logout":"LogoutButton_logout__z-the","logoutIcon":"LogoutButton_logoutIcon__vSfAS"};